import { useEffect } from "react";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const Impressum = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://legal.flh-mediadigital.de/rewe-partner.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      script.remove();
    };
  }, []);

  return (
  <>
      <Seo title="Impressum | Rewe Kotlarski Meerbusch-Osterath" description="Impressum und Anbieterkennzeichnung der Rewe Peter Kotlarski OHG, Bommershöferweg 2–8, 40670 Meerbusch-Osterath." />
    <PageHeader tag="Rechtliches" title="Impressum" />
    <section className="py-16 px-6 md:px-16">
      <div className="max-w-3xl mx-auto font-body text-muted-foreground space-y-8 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_h2]:mb-3 [&_h2]:[hyphens:none] [&_p]:leading-relaxed" style={{ textWrap: "pretty" as any }}>
        <div>
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>Rewe Peter Kotlarski OHG</p>
          <p>Bommershöferweg 2–8</p>
          <p>40670 Meerbusch-Osterath</p>
        </div>

        <div>
          <h2>Vertreten durch die vertretungsberechtigten Gesellschafter</h2>
          <p>Peter Kotlarski</p>
          <div id="rewe-partner-data" />
        </div>

        <div>
          <h2>Kontakt</h2>
          <p>
            <span className="inline-block">Telefon: +49 2159 912974</span>
          </p>
          <p>
            <span className="inline-block">
              E-Mail:{" "}
              <a href="mailto:info@rewe-kotlarski.de" className="text-primary-bright underline hover:text-primary-bright/80 transition-colors">
                info@rewe-kotlarski.de
              </a>
            </span>
          </p>
        </div>

        <div>
          <h2>Handelsregister</h2>
          <p>Registergericht: Amtsgericht Neuss</p>
          <p>Registernummer: HRA 7310</p>
        </div>

        <div>
          <h2>Umsatzsteuer-ID</h2>
          <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: DE 64239980570</p>
        </div>

        <div>
          <h2>Zuständige Aufsichtsbehörde</h2>
          <p>Lebensmittelüberwachung: Auf der Schanze 4, 41515 Grevenbroich</p>
        </div>

        <div>
          <h2>Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
        </div>

        <div>
          <h2>Haftung für Links</h2>
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
        </div>

        <div>
          <h2>Urheberrecht</h2>
          <p>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </div>
      </div>
    </section>
  </>
  );
};

export default Impressum;